import { useSnackbar } from "notistack";
import Box from "@mui/material/Box";
import { useQuery } from "@tanstack/react-query";
import { manage_booking_api } from "src/DAL/HelpingVideos/AdminHelpingVideosCategory";
import { s3baseUrl } from "src/config/config";
import icons from "src/design-system/icons";
import GrPage from "src/design-system/components/GrPage";
import GrPageHeader from "src/design-system/components/GrPageHeader";
import GrMediaCard from "src/design-system/components/GrMediaCard";
import GrButton from "src/design-system/components/GrButton";
import GrIcon from "src/design-system/components/GrIcon";
import GrCard from "src/design-system/components/GrCard";
import GrEmptyState from "src/design-system/components/GrEmptyState";
import GrLoader from "src/design-system/components/GrLoader";
import { isFirstRow, libraryGridSx, ownAction } from "../Video/videoHelpers";

/**
 * Booking (/redirect-page): the gym's booking pages as cards. The card or its button opens the
 * booking page in a new tab.
 */

// The card's one button fills the action row (as on the Programmes / Videos cards).
const cardButtonSx = { flex: "1 1 0", minWidth: 0 };

export default function RedirectPage() {
  const { enqueueSnackbar } = useSnackbar();

  const { data: bookings = [], isLoading } = useQuery({
    queryKey: ["manageBooking"],
    queryFn: async () => {
      const result = await manage_booking_api();
      if (result?.code !== 200) {
        throw new Error(result?.message);
      }
      return result;
    },
    select: (result) => result?.booking_information || [],
    onError: (error) => {
      enqueueSnackbar(error?.message, { variant: "error" });
    },
  });

  const handleRedirect = (url) => {
    if (url) {
      window.open(url, "_blank", "noopener");
    }
  };

  return (
    <GrPage>
      <GrPageHeader title="Booking" />

      {isLoading ? (
        <GrLoader />
      ) : bookings.length > 0 ? (
        <Box sx={libraryGridSx}>
          {bookings.map((value, index) => {
            const thumb = value?.image?.thumbnail_1;
            return (
              <GrMediaCard
                eagerImage={isFirstRow(index)}
                key={value?._id || index}
                image={thumb ? s3baseUrl + thumb : null}
                imageAlt={value?.title || ""}
                placeholderIcon={icons.clock}
                title={value?.title || ""}
                description={value?.description}
                meta={value?.program || null}
                onClick={() => handleRedirect(value?.redirect_url)}
                actions={
                  <GrButton
                    variant="outline"
                    size="sm"
                    sx={cardButtonSx}
                    endIcon={<GrIcon icon={icons.external} size="sm" />}
                    {...ownAction(() => handleRedirect(value?.redirect_url))}
                  >
                    Book now
                  </GrButton>
                }
              />
            );
          })}
        </Box>
      ) : (
        <GrCard>
          <GrEmptyState icon={<GrIcon icon={icons.clock} />} title="Data Not Found" />
        </GrCard>
      )}
    </GrPage>
  );
}
